// import React, { useState, useEffect } from 'react';
// import { FaSave, FaPlus, FaTrash } from 'react-icons/fa';

// const AdminContactPanel = () => {
//   // Stan dla danych kontaktowych
//   const [contactData, setContactData] = useState({
//     title: "Zapraszamy",
//     contactTitle: "Kontakt",
//     locations: [
//       {
//         name: "Kolorowe Domki",
//         address: "ul. Wiatrakowa 30\n84-104 Jastrzębia Góra"
//       },
//       {
//         name: "Apartamenty",
//         address: "ul. Rydzowa 1\n84-104 Jastrzębia Góra - Tupadły"
//       }
//     ],
//     phone: "+48 608 025 978",
//     email: "kontakt@kolorowedomki.com",
//     hours: "Pon-Pt: 9:00 - 18:00",
//     formTitle: "Wyślij zapytanie",
//     consentText: "Wypełniając formularz i klikając przycisk „Wyślij\", wyrażasz zgodę na przesłanie Twojego zapytania, w tym Twoich danych osobowych. Administratorem Twoich danych osobowych jest <strong>Kolorowe Domki, ul. Wiatrakowa 30, 84-104 Jastrzębia Góra, NIP: [TUTAJ WSTAW NIP]</strong>. Szczegóły w jaki sposób przetwarzamy Twoje dane oraz jakie prawa z tym związane znajdziesz w naszej <a href=\"/polityka-prywatnosci\" class=\"text-yellow-600 hover:text-yellow-700 underline\">Polityce Prywatności</a>.",
//     mapsTitle: "Gdzie nas znajdziesz",
//     maps: [
//       {
//         title: "Mapa: Kolorowe Domki",
//         url: "https://www.google.pl/maps/place/Kolorowe+Domki+Jastrz%C4%99bia+G%C3%B3ra/@54.8267214,18.3217428,17z/data=!3m1!4b1!4m6!3m5!1s0x46fc4b29b9b7bebb:0x5b107c7de8090dc!8m2!3d54.8267183!4d18.3243177!16s%2Fg%2F11kpzwbdzd?entry=tt"
//       },
//       {
//         title: "Mapa: Apartamenty Kolorowe Domki",
//         url: "https://www.google.pl/maps/place/Apartamenty+Kolorowe+Domki/@54.825977,18.321132,17z/data=!3m1!4b1!4m6!3m5!1s0x46fc4b3498a3f99f:0xce86cb90a9dfbc7a!8m2!3d54.8259739!4d18.3237069!16s%2Fg%2F11fprzqp29?entry=ttu"
//       }
//     ]
//   });

//   const [message, setMessage] = useState("");

//   // Załaduj dane z localStorage przy starcie
//   useEffect(() => {
//     const savedData = localStorage.getItem('contactData');
//     if (savedData) {
//       try {
//         setContactData(JSON.parse(savedData));
//       } catch (error) {
//         console.error('Błąd parsowania danych kontaktowych:', error);
//       }
//     }
//   }, []);

//   const saveData = () => {
//     localStorage.setItem('contactData', JSON.stringify(contactData));
//     setMessage("Zmiany zapisane pomyślnie!");
//     setTimeout(() => setMessage(""), 3000);
//   };

//   const handleGeneralChange = (field, value) => {
//     setContactData({
//       ...contactData,
//       [field]: value
//     });
//   };

//   const handleLocationChange = (index, field, value) => {
//     const updatedLocations = [...contactData.locations];
//     updatedLocations[index] = {
//       ...updatedLocations[index],
//       [field]: value
//     };
    
//     setContactData({
//       ...contactData,
//       locations: updatedLocations
//     });
//   };

//   const addLocation = () => {
//     setContactData({
//       ...contactData,
//       locations: [
//         ...contactData.locations,
//         {
//           name: "Nowa lokalizacja",
//           address: "Adres lokalizacji"
//         }
//       ]
//     });
//   };

//   const removeLocation = (index) => {
//     if (contactData.locations.length <= 1) {
//       setMessage("Musisz mieć przynajmniej jedną lokalizację!");
//       setTimeout(() => setMessage(""), 3000);
//       return;
//     }
    
//     setContactData({
//       ...contactData,
//       locations: contactData.locations.filter((_, i) => i !== index)
//     });
//   };

//   const handleMapChange = (index, field, value) => {
//     const updatedMaps = [...contactData.maps];
//     updatedMaps[index] = {
//       ...updatedMaps[index],
//       [field]: value
//     };
    
//     setContactData({
//       ...contactData,
//       maps: updatedMaps
//     });
//   };

//   const addMap = () => {
//     setContactData({
//       ...contactData,
//       maps: [
//         ...contactData.maps,
//         {
//           title: "Nowa mapa",
//           url: "https://maps.google.com/"
//         }
//       ]
//     });
//   };

//   const removeMap = (index) => {
//     if (contactData.maps.length <= 1) {
//       setMessage("Musisz mieć przynajmniej jedną mapę!");
//       setTimeout(() => setMessage(""), 3000);
//       return;
//     }
    
//     setContactData({
//       ...contactData,
//       maps: contactData.maps.filter((_, i) => i !== index)
//     });
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 p-6">
//       <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6">
//         <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Kontakt</h1>
        
//         {message && (
//           <div className="mb-4 p-3 bg-green-100 text-green-700 rounded">
//             {message}
//           </div>
//         )}
        
//         {/* Nagłówki */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-4">Nagłówki</h2>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-2">Główny tytuł</label>
//             <input
//               type="text"
//               value={contactData.title}
//               onChange={(e) => handleGeneralChange('title', e.target.value)}
//               className="w-full p-3 border border-gray-300 rounded-md"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł sekcji kontaktowej</label>
//             <input
//               type="text"
//               value={contactData.contactTitle}
//               onChange={(e) => handleGeneralChange('contactTitle', e.target.value)}
//               className="w-full p-3 border border-gray-300 rounded-md"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł formularza</label>
//             <input
//               type="text"
//               value={contactData.formTitle}
//               onChange={(e) => handleGeneralChange('formTitle', e.target.value)}
//               className="w-full p-3 border border-gray-300 rounded-md"
//             />
//           </div>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł map</label>
//             <input
//               type="text"
//               value={contactData.mapsTitle}
//               onChange={(e) => handleGeneralChange('mapsTitle', e.target.value)}
//               className="w-full p-3 border border-gray-300 rounded-md"
//             />
//           </div>
//         </div>

//         {/* Lokalizacje */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-4">Lokalizacje</h2>
          
//           <div className="space-y-4">
//             {contactData.locations.map((location, index) => (
//               <div key={index} className="p-4 border border-gray-200 rounded-md">
//                 <div className="flex items-center justify-between mb-4">
//                   <h3 className="font-medium">Lokalizacja {index + 1}</h3>
//                   <button
//                     onClick={() => removeLocation(index)}
//                     className="p-2 bg-red-100 text-red-600 rounded-md"
//                   >
//                     <FaTrash />
//                   </button>
//                 </div>
                
//                 <div className="mb-4">
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Nazwa lokalizacji</label>
//                   <input
//                     type="text"
//                     value={location.name}
//                     onChange={(e) => handleLocationChange(index, 'name', e.target.value)}
//                     className="w-full p-2 border border-gray-300 rounded-md"
//                   />
//                 </div>
                
//                 <div className="mb-4">
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Adres (używaj \n dla nowej linii)</label>
//                   <textarea
//                     value={location.address}
//                     onChange={(e) => handleLocationChange(index, 'address', e.target.value)}
//                     className="w-full p-2 border border-gray-300 rounded-md h-20"
//                     placeholder="ul. Przykładowa 1&#10;00-000 Miasto"
//                   />
//                 </div>
//               </div>
//             ))}
//           </div>
          
//           <button
//             onClick={addLocation}
//             className="mt-4 flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-md"
//           >
//             <FaPlus /> Dodaj lokalizację
//           </button>
//         </div>

//         {/* Dane kontaktowe */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-4">Dane kontaktowe</h2>
          
//           <div className="grid md:grid-cols-2 gap-4">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">Telefon</label>
//               <input
//                 type="text"
//                 value={contactData.phone}
//                 onChange={(e) => handleGeneralChange('phone', e.target.value)}
//                 className="w-full p-2 border border-gray-300 rounded-md"
//               />
//             </div>
            
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
//               <input
//                 type="email"
//                 value={contactData.email}
//                 onChange={(e) => handleGeneralChange('email', e.target.value)}
//                 className="w-full p-2 border border-gray-300 rounded-md"
//               />
//             </div>
            
//             <div className="md:col-span-2">
//               <label className="block text-sm font-medium text-gray-700 mb-2">Godziny pracy</label>
//               <input
//                 type="text"
//                 value={contactData.hours}
//                 onChange={(e) => handleGeneralChange('hours', e.target.value)}
//                 className="w-full p-2 border border-gray-300 rounded-md"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Tekst zgody */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-4">Tekst zgody RODO</h2>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-2">Tekst zgody (używaj znaczników HTML dla formatowania)</label>
//             <textarea
//               value={contactData.consentText}
//               onChange={(e) => handleGeneralChange('consentText', e.target.value)}
//               className="w-full p-2 border border-gray-300 rounded-md h-32"
//             />
//           </div>
//         </div>

//         {/* Mapy */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-4">Mapy</h2>
          
//           <div className="space-y-4">
//             {contactData.maps.map((map, index) => (
//               <div key={index} className="p-4 border border-gray-200 rounded-md">
//                 <div className="flex items-center justify-between mb-4">
//                   <h3 className="font-medium">Mapa {index + 1}</h3>
//                   <button
//                     onClick={() => removeMap(index)}
//                     className="p-2 bg-red-100 text-red-600 rounded-md"
//                   >
//                     <FaTrash />
//                   </button>
//                 </div>
                
//                 <div className="mb-4">
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł mapy</label>
//                   <input
//                     type="text"
//                     value={map.title}
//                     onChange={(e) => handleMapChange(index, 'title', e.target.value)}
//                     className="w-full p-2 border border-gray-300 rounded-md"
//                   />
//                 </div>
                
//                 <div className="mb-4">
//                   <label className="block text-sm font-medium text-gray-700 mb-2">URL mapy Google</label>
//                   <input
//                     type="url"
//                     value={map.url}
//                     onChange={(e) => handleMapChange(index, 'url', e.target.value)}
//                     className="w-full p-2 border border-gray-300 rounded-md"
//                     placeholder="https://maps.google.com/..."
//                   />
//                 </div>
//               </div>
//             ))}
//           </div>
          
//           <button
//             onClick={addMap}
//             className="mt-4 flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-md"
//           >
//             <FaPlus /> Dodaj mapę
//           </button>
//         </div>

//         {/* Zapisywanie */}
//         <div className="flex justify-end">
//           <button
//             onClick={saveData}
//             className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
//           >
//             <FaSave /> Zapisz zmiany
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminContactPanel;

import React, { useState, useEffect } from 'react';
import { FaSave, FaPlus, FaTrash } from 'react-icons/fa';

const AdminContactPanel = () => {
  const API_BASE = 'http://localhost/api';

  // Stan dla danych kontaktowych
  const [contactData, setContactData] = useState({
    title: "Zapraszamy",
    contactTitle: "Kontakt",
    locations: [
      {
        name: "Kolorowe Domki",
        address: "ul. Wiatrakowa 30\n84-104 Jastrzębia Góra"
      },
      {
        name: "Apartamenty",
        address: "ul. Rydzowa 1\n84-104 Jastrzębia Góra - Tupadły"
      }
    ],
    phone: "+48 608 025 978",
    email: "kontakt@kolorowedomki.com",
    hours: "Pon-Pt: 9:00 - 18:00",
    formTitle: "Wyślij zapytanie",
    consentText: "Wypełniając formularz i klikając przycisk „Wyślij\", wyrażasz zgodę na przesłanie Twojego zapytania, w tym Twoich danych osobowych. Administratorem Twoich danych osobowych jest <strong>Kolorowe Domki, ul. Wiatrakowa 30, 84-104 Jastrzębia Góra, NIP: 5291267100 </strong>. Szczegóły w jaki sposób przetwarzamy Twoje dane oraz jakie prawa z tym związane znajdziesz w naszej <a href=\"/polityka-prywatnosci\" class=\"text-yellow-600 hover:text-yellow-700 underline\">Polityce Prywatności</a>.",
    mapsTitle: "Gdzie nas znajdziesz",
    maps: [
      {
        title: "Mapa: Kolorowe Domki",
        url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2326.874366284683!2d18.3217428!3d54.8267214!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46fc4b29b9b7bebb%3A0x5b107c7de8090dc!2sKolorowe%20Domki%20Jastrz%C4%99bia%20G%C3%B3ra!5e0!3m2!1spl!2spl!4v1700000000000!5m2!1spl!2spl"
      },
      {
        title: "Mapa: Apartamenty Kolorowe Domki",
        url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2326.856789012345!2d18.321132!3d54.825977!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46fc4b3498a3f99f%3A0xce86cb90a9dfbc7a!2sApartamenty%20Kolorowe%20Domki!5e0!3m2!1spl!2spl!4v1700000000000!5m2!1spl!2spl"
      }
    ]
  });

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);

  // Załaduj dane z serwera
  useEffect(() => {
    const fetchContactData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE}/contact.php`);
        
        if (!response.ok) {
          throw new Error('Błąd podczas pobierania danych kontaktowych');
        }
        
        const data = await response.json();
        setContactData(data);
      } catch (error) {
        console.error('Błąd ładowania danych kontaktowych:', error);
        setMessage('Błąd połączenia z serwerem - używam domyślnych danych');
        setTimeout(() => setMessage(""), 5000);
      } finally {
        setLoading(false);
      }
    };

    fetchContactData();
  }, []);

  // Zapisz dane na serwerze
  const saveData = () => {
    fetch(`${API_BASE}/contact.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(contactData),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Błąd serwera');
      }
      return response.json();
    })
    .then(data => {
      setMessage(data.message || "Zmiany zapisane pomyślnie!");
      setTimeout(() => setMessage(""), 3000);
    })
    .catch(error => {
      setMessage("Błąd podczas zapisywania danych");
      console.error('Błąd:', error);
      setTimeout(() => setMessage(""), 5000);
    });
  };

  const handleGeneralChange = (field, value) => {
    setContactData({
      ...contactData,
      [field]: value
    });
  };

  const handleLocationChange = (index, field, value) => {
    const updatedLocations = [...contactData.locations];
    updatedLocations[index] = {
      ...updatedLocations[index],
      [field]: value
    };
    
    setContactData({
      ...contactData,
      locations: updatedLocations
    });
  };

  const addLocation = () => {
    setContactData({
      ...contactData,
      locations: [
        ...contactData.locations,
        {
          name: "Nowa lokalizacja",
          address: "Adres lokalizacji"
        }
      ]
    });
  };

  const removeLocation = (index) => {
    if (contactData.locations.length <= 1) {
      setMessage("Musisz mieć przynajmniej jedną lokalizację!");
      setTimeout(() => setMessage(""), 3000);
      return;
    }
    
    setContactData({
      ...contactData,
      locations: contactData.locations.filter((_, i) => i !== index)
    });
  };

  const handleMapChange = (index, field, value) => {
    const updatedMaps = [...contactData.maps];
    updatedMaps[index] = {
      ...updatedMaps[index],
      [field]: value
    };
    
    setContactData({
      ...contactData,
      maps: updatedMaps
    });
  };

  const addMap = () => {
    setContactData({
      ...contactData,
      maps: [
        ...contactData.maps,
        {
          title: "Nowa mapa",
          url: "https://maps.google.com/"
        }
      ]
    });
  };

  const removeMap = (index) => {
    if (contactData.maps.length <= 1) {
      setMessage("Musisz mieć przynajmniej jedną mapę!");
      setTimeout(() => setMessage(""), 3000);
      return;
    }
    
    setContactData({
      ...contactData,
      maps: contactData.maps.filter((_, i) => i !== index)
    });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 p-6">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6">
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Kontakt</h1>
        
        {message && (
          <div className={`mb-4 p-3 rounded ${
            message.includes('Błąd') ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
          }`}>
            {message}
          </div>
        )}
        
        {/* Nagłówki */}
        <div className="mb-8 p-4 border border-gray-200 rounded-md">
          <h2 className="text-lg font-semibold mb-4">Nagłówki</h2>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">Główny tytuł</label>
            <input
              type="text"
              value={contactData.title}
              onChange={(e) => handleGeneralChange('title', e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-md"
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł sekcji kontaktowej</label>
            <input
              type="text"
              value={contactData.contactTitle}
              onChange={(e) => handleGeneralChange('contactTitle', e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-md"
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł formularza</label>
            <input
              type="text"
              value={contactData.formTitle}
              onChange={(e) => handleGeneralChange('formTitle', e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-md"
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł map</label>
            <input
              type="text"
              value={contactData.mapsTitle}
              onChange={(e) => handleGeneralChange('mapsTitle', e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-md"
            />
          </div>
        </div>

        {/* Lokalizacje */}
        <div className="mb-8 p-4 border border-gray-200 rounded-md">
          <h2 className="text-lg font-semibold mb-4">Lokalizacje</h2>
          
          <div className="space-y-4">
            {contactData.locations.map((location, index) => (
              <div key={index} className="p-4 border border-gray-200 rounded-md">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-medium">Lokalizacja {index + 1}</h3>
                  <button
                    onClick={() => removeLocation(index)}
                    className="p-2 bg-red-100 text-red-600 rounded-md"
                  >
                    <FaTrash />
                  </button>
                </div>
                
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Nazwa lokalizacji</label>
                  <input
                    type="text"
                    value={location.name}
                    onChange={(e) => handleLocationChange(index, 'name', e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md"
                  />
                </div>
                
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Adres (używaj \n dla nowej linii)</label>
                  <textarea
                    value={location.address}
                    onChange={(e) => handleLocationChange(index, 'address', e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md h-20"
                    placeholder="ul. Przykładowa 1&#10;00-000 Miasto"
                  />
                </div>
              </div>
            ))}
          </div>
          
          <button
            onClick={addLocation}
            className="mt-4 flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-md"
          >
            <FaPlus /> Dodaj lokalizację
          </button>
        </div>

        {/* Dane kontaktowe */}
        <div className="mb-8 p-4 border border-gray-200 rounded-md">
          <h2 className="text-lg font-semibold mb-4">Dane kontaktowe</h2>
          
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Telefon</label>
              <input
                type="text"
                value={contactData.phone}
                onChange={(e) => handleGeneralChange('phone', e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
              <input
                type="email"
                value={contactData.email}
                onChange={(e) => handleGeneralChange('email', e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-2">Godziny pracy</label>
              <input
                type="text"
                value={contactData.hours}
                onChange={(e) => handleGeneralChange('hours', e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
          </div>
        </div>

        {/* Tekst zgody */}
        <div className="mb-8 p-4 border border-gray-200 rounded-md">
          <h2 className="text-lg font-semibold mb-4">Tekst zgody RODO</h2>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">Tekst zgody (używaj znaczników HTML dla formatowania)</label>
            <textarea
              value={contactData.consentText}
              onChange={(e) => handleGeneralChange('consentText', e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md h-32"
            />
          </div>
        </div>

        {/* Mapy */}
        <div className="mb-8 p-4 border border-gray-200 rounded-md">
          <h2 className="text-lg font-semibold mb-4">Mapy</h2>
          
          <div className="space-y-4">
            {contactData.maps.map((map, index) => (
              <div key={index} className="p-4 border border-gray-200 rounded-md">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-medium">Mapa {index + 1}</h3>
                  <button
                    onClick={() => removeMap(index)}
                    className="p-2 bg-red-100 text-red-600 rounded-md"
                  >
                    <FaTrash />
                  </button>
                </div>
                
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł mapy</label>
                  <input
                    type="text"
                    value={map.title}
                    onChange={(e) => handleMapChange(index, 'title', e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md"
                  />
                </div>
                
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">URL mapy Google</label>
                  <input
                    type="url"
                    value={map.url}
                    onChange={(e) => handleMapChange(index, 'url', e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md"
                    placeholder="https://maps.google.com/..."
                  />
                </div>
              </div>
            ))}
          </div>
          
          <button
            onClick={addMap}
            className="mt-4 flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-md"
          >
            <FaPlus /> Dodaj mapę
          </button>
        </div>

        {/* Zapisywanie */}
        <div className="flex justify-end">
          <button
            onClick={saveData}
            className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
          >
            <FaSave /> Zapisz zmiany
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminContactPanel;